import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Menu,
  MenuItem,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React from "react";

const DealerList = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("pending");

  const dealers = [
    {
      id: 1,
      showroomName: "Auto Hub",
      showroomImage: "/static/images/placeholder.png",
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      address: "Pune, Maharashtra, India",
      listedCars: 5,
      status: "pending",
      registeredDate: "01 March 2025",
    },
    {
      id: 2,
      showroomName: "Car Zone",
      showroomImage: "/static/images/placeholder.png",
      name: "John Smith",
      email: "john@example.com",
      phone: "+91 9000011111",
      address: "Mumbai, Maharashtra, India",
      listedCars: 2,
      status: "accepted",
      registeredDate: "15 February 2025",
    },
    {
      id: 3,
      showroomName: "Speed Motors",
      showroomImage: "/static/images/placeholder.png",
      name: "Alex Brown",
      email: "alex@gmail.com",
      phone: "+91 8112233445",
      address: "Delhi, India",
      listedCars: 8,
      status: "rejected",
      registeredDate: "20 February 2025",
    },
  ];

  const filteredDealers = dealers.filter(
    (dealer) => dealer.status === tab
  );

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box className="custom_tabs" sx={{ width: "100%" }}>
        <Tabs
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
          className="custom_tabs_links"
        >
          <Tab label="Pending" value="pending" />
          <Tab label="Accepted" value="accepted" />
          <Tab label="Rejected" value="rejected" />
        </Tabs>
      </Box>

      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Showroom Detail</TableCell>
              <TableCell>Dealer Detail</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Cars</TableCell>
              <TableCell>
                {tab === "accepted" && <>Enable/Disable</>}
                {tab === "pending" && (<>Status</>)}
                {tab === "rejected" && (<>Status</>)}
              </TableCell>
              <TableCell>Registered Date</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredDealers.map((dealer) => (
              <TableRow hover key={dealer.id}>
                {/* SHOWROOM DETAIL */}
                <TableCell>
                  <div className="user_block">
                    <figure className="no_radius">
                      <img src={dealer.showroomImage} alt="Showroom" />
                    </figure>
                    <p>
                      <b>{dealer.showroomName}</b>
                    </p>
                  </div>
                </TableCell>

                {/* DEALER DETAIL */}
                <TableCell>
                  <div className="user_block">
                    <p>
                      <b>{dealer.name}</b>
                      <span>{dealer.phone}</span>
                      <span>{dealer.email}</span>
                    </p>
                  </div>
                </TableCell>

                {/* ADDRESS */}
                <TableCell>{dealer.address}</TableCell>

                {/* LISTED CARS */}
                <TableCell>{dealer.listedCars}</TableCell>

                {/* STATUS */}
                <TableCell>
                  {tab === "accepted" && <SwitchToggle defaultChecked />}
                  {tab === "pending" && (
                    <span className="status_btn dark c_warning">Pending</span>
                  )}
                  {tab === "rejected" && (
                    <span className="status_btn dark c_danger">Rejected</span>
                  )}
                </TableCell>

                {/* DATE */}
                <TableCell>{dealer.registeredDate}</TableCell>

                {/* ACTION */}
                <TableCell>
                  <div className="table_actions v2">
                    {tab === "pending" && (
                      <>
                        <IconButton
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={handleClick}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                          transformOrigin={{ horizontal: "right", vertical: "top" }}
                          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                        >
                          <MenuItem onClick={() => { handleClose() }}>Accept</MenuItem>
                          <MenuItem onClick={() => { handleClose() }}>Reject</MenuItem>
                        </Menu>
                      </>
                    )}
                    <IconButton
                      onClick={() => navigate("/manage-dealers/detail")}
                    >
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>

                    <IconButton
                      onClick={() => navigate("/manage-dealers/edit")}
                    >
                      <img src="/static/images/edit2_icon.svg" alt="Edit" />
                    </IconButton>

                    <IconButton>
                      <img
                        src="/static/images/trash2_icon.svg"
                        alt="Delete"
                      />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}

            {filteredDealers.length === 0 && (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DealerList;
